import React from 'react';
import { Chip } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
import type { AffiliateData, ClothingItem } from '../../types';

interface AffiliateLinkProps {
  item: ClothingItem;
  affiliate: AffiliateData;
}

/**
 * AffiliateLink — styled chip link for tagged clothing items with affiliate data.
 * Opens in a new tab with proper security attributes.
 * Only renders when affiliate data is present (caller is responsible for the check).
 */
const AffiliateLink: React.FC<AffiliateLinkProps> = ({ item, affiliate }) => {
  const label = affiliate.price
    ? `${item.brand || item.description} · ${affiliate.price}`
    : item.brand || item.description;

  return (
    <Chip
      component="a"
      href={affiliate.affiliateUrl}
      target="_blank"
      rel="noopener noreferrer"
      clickable
      size="small"
      icon={<OpenInNew sx={{ fontSize: '0.85rem' }} />}
      label={label}
      aria-label={`Shop ${item.brand || item.description} on ${affiliate.provider}`}
      sx={{
        fontSize: '0.7rem',
        height: 26,
        borderRadius: 2,
        backgroundColor: 'rgba(124, 58, 237, 0.12)',
        color: 'text.primary',
        border: '1px solid',
        borderColor: 'divider',
        '&:hover': {
          backgroundColor: 'rgba(124, 58, 237, 0.22)',
        },
        '& .MuiChip-icon': {
          color: 'text.secondary',
        },
      }}
    />
  );
};

export default AffiliateLink;
